export default [
  {
    path: '/shows',
    name: 'shows',
    component: () => import('../../views/shows/shows.vue'),
    meta: {
      pageTitle: 'Videos',
      breadcrumbs: ['Videos', 'Shows'],
    },
    children:[
      {
        path: '',
        name: 'shows-list',
        component: () => import('../../views/shows/list.vue')
      },
      {
        path: 'create',
        name: 'shows-create',
        component: () => import('../../views/shows/create.vue'),
        meta: {
          pageTitle: 'Create Shows',
          breadcrumbs: ['Shows', 'Create'],
        }
      },
      {
        path: ':id/edit',
        name: 'shows-edit',
        component: () => import('../../views/shows/edit.vue'),
        meta: {
          pageTitle: 'Edit Shows',
          breadcrumbs: ['Shows', 'Edit'],
        }
      },
      {
        path: ':id/episodes',
        name: 'shows-episodes-list',
        component: () => import('../../views/shows/episodes/list.vue'),
        meta: {
          pageTitle: 'Show Episodes',
          breadcrumbs: ['Show', 'Episodes'],
        }
      },
      {
        path: ':id/episodes/create',
        name: 'shows-episodes-create',
        component: () => import('../../views/shows/episodes/create.vue'),
        meta: {
          pageTitle: 'Create Episode',
          breadcrumbs: ['Show', 'Episodes', 'Create'],
        }
      },
      {
        path: ':id/episodes/:epId/edit',
        name: 'shows-episodes-edit',
        component: () => import('../../views/shows/episodes/edit.vue'),
        meta: {
          pageTitle: 'Edit Episode',
          breadcrumbs: ['Show', 'Episodes', 'Edit'],
        }
      }
    ]
  }
  // {
  //   path: '/episodes',
  //   name: 'episodes',
  //   component: () => import('../../views/episodes/episodes.vue'),
  //   meta: {
  //     pageTitle: 'Videos',
  //     breadcrumbs: ['Videos', 'Episodes'],
  //   },
  // },
]
